import Reveal from "../components/Reveal";

export default function Legal({ kind = "privacy" }) {
  const isPrivacy = kind === "privacy";
  return (
    <main data-testid={`${kind}-page`} className="pt-32 pb-24 max-w-3xl mx-auto px-6 md:px-12">
      <Reveal>
        <h1 className="font-display text-5xl md:text-6xl font-light mb-8">
          {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        </h1>
        <div className="prose prose-neutral dark:prose-invert max-w-none text-foreground/80 leading-relaxed space-y-4">
          {isPrivacy ? (
            <>
              <p>We only collect what we need to plan your trip — name, contact details, travel dates and preferences.</p>
              <p>We never sell your data. We share it only with hotels, drivers and guides directly involved in your itinerary.</p>
              <p>You can request deletion of your data at any time by emailing hello@northeastodyssey.in.</p>
            </>
          ) : (
            <>
              <p>Bookings are confirmed only after written confirmation from our team and receipt of the agreed deposit.</p>
              <p>Cancellations 30+ days before travel are refunded in full minus a 5% admin fee. Within 15 days: 50%. Within 7 days: non-refundable.</p>
              <p>We are not liable for delays caused by weather, road closures or political events. We will, however, do everything possible to keep your trip on track.</p>
            </>
          )}
        </div>
      </Reveal>
    </main>
  );
}
